// @flow

import type { ExtractReturn } from '@ta/common.types';
import type { Action as AllActions } from '../state';
import type { State as PageState } from '../page';
import { SET_HOTELS_DATES_GUESTS } from '../travelerInfo/hotels';

const SET_GEO = 'SET_GEO';
export const setGeo = (geoId: number) => ({
  type: SET_GEO,
  geoId,
});

const SET_PAGE_OFFSET = 'SET_PAGE_OFFSET';
export const setPageOffset = (pageOffset: number) => ({
  type: SET_PAGE_OFFSET,
  pageOffset,
});

const POLL = 'POLL';
export const poll = () => ({
  type: POLL,
});

const SET_SORT = 'SET_SORT';
export const setSort = (sortOrder: string) => ({
  type: SET_SORT,
  sortOrder,
});

const SET_FILTERS = 'SET_FILTERS';
export const setFilters = (filters: string) => ({
  type: SET_FILTERS,
  filters,
});

export type Action =
  | ExtractReturn<typeof setGeo>
  | ExtractReturn<typeof setPageOffset>
  | ExtractReturn<typeof poll>
  | ExtractReturn<typeof setSort>
  | ExtractReturn<typeof setFilters>;

const emptyState = () => ({
  name: 'HOTELS',
  geoId: 0,
  pageNumber: 1,
  requestNumber: 1,
  sort: '',
  filters: '',
});

export type State = ExtractReturn<typeof emptyState>;

export default (state: PageState = emptyState(), action: AllActions): PageState => {
  switch (action.type) {
    case SET_HOTELS_DATES_GUESTS:
      return { ...state, requestNumber: 1 };
    case SET_GEO:
      return { ...state, geoId: action.geoId, pageNumber: 1, requestNumber: 1 };
    case POLL:
      return { ...state, requestNumber: (state.requestNumber || 0) + 1 };
    case SET_SORT:
      return { ...state, sort: action.sortOrder, requestNumber: 1 };
    case SET_FILTERS:
      return { ...state, filters: action.filters, requestNumber: 1 };
    case SET_PAGE_OFFSET:
      return { ...state, pageOffset: action.pageOffset, requestNumber: 1 };
    default:
      return state;
  }
};
